export default {
  validCode: null,
  productIdsForValidCode: null,
};
